"use strict";
/**
|--------------------------------------------------
| Swiper
|--------------------------------------------------
*/

import Swiper from 'swiper';
import {
	Navigation,    // Enables next/prev navigation buttons
	Pagination,    // Adds pagination bullets
	Scrollbar,     // Enables a draggable scrollbar
	Autoplay,      // Auto-plays the slides
	EffectFade,    // Adds fade transition effect
	EffectCube,    // Cube effect for slides
	EffectFlip,    // Flip effect for slides
	EffectCoverflow, // Coverflow effect
	EffectCreative,  // Creative effects (customizable)
	EffectCards,     // Stack-like card effect
	Thumbs,       // Enables thumbnail navigation
	FreeMode,     // Allows free scrolling
	Grid,         // Enables grid layout slides
	Keyboard,     // Enables keyboard navigation
	Mousewheel,   // Enables scrolling with a mouse wheel
	Parallax,     // Enables parallax effect
	Virtual,      // Virtual slides for large datasets
	Zoom,         // Zoom functionality
	Lazy,         // Lazy loading for images
	Controller,   // Sync multiple Swipers
	A11y,         // Accessibility features
	History,      // URL history tracking
	HashNavigation, // Enables hash navigation
	Manipulation  // Allows slide elements to be dynamically modified
} from 'swiper/modules';
  
// Uncomment only the ones you actually need.
Swiper.use([
	Navigation,
	Pagination,
	// Scrollbar,
	// Autoplay,
	// EffectFade,
	// EffectCube,
	// EffectFlip,
	// EffectCoverflow,
	// EffectCreative,
	// EffectCards,
	Thumbs,
	// FreeMode,
	// Grid,
	// Keyboard,
	// Mousewheel,
	// Parallax,
	// Virtual,
	// Zoom,
	// Lazy,
	// Controller,
	A11y,
	// History,
	// HashNavigation,
	// Manipulation
]);

export const initSwiper = (selector) => {
	const swipers = document.querySelectorAll(selector);
	swipers.forEach(swiper => {
		if(!swiper.dataset.config) return;
		const config = JSON.parse(swiper.dataset.config);
		new Swiper(swiper, config);
	});
};

const swiperGallery = new Swiper(".swiperGallery", {
	spaceBetween: 20,
	slidesPerView: 4,
	freeMode: true,
	watchSlidesProgress: true,
});

const mySwiper = new Swiper(".mySwiper", {
	spaceBetween: 0,
	// slidesPerView: 4,
	// freeMode: true,
	// watchSlidesProgress: true,
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
	breakpoints: {
		0: {
			slidesPerView: 3,
		},
		992: {
			slidesPerView: 3,
		},
		1400: {
			slidesPerView: 4,
		},
	}
});

const swiperThumbs = new Swiper(".swiperThumbs", {
	spaceBetween: 10,
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
	thumbs: {
		swiper: swiperGallery,
	},
});

const mySwiper2 = new Swiper(".mySwiper2", {
	spaceBetween: 10,
	thumbs: {
		swiper: mySwiper,
	},
});

